import { render, staticRenderFns } from "./selectize.vue?vue&type=template&id=8b3fe814&"
import script from "./selectize.vue?vue&type=script&lang=js&"
export * from "./selectize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports